/**
 * @file components/log/weightCharts/WeeklyDeficitChart.jsx
 * @description Weekly deficit the user achieved vs their weekly goal.
 */

import {
  Bar,
  CartesianGrid,
  Cell,
  ComposedChart,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  CHART_MARGIN,
  GRID_PROPS,
  X_AXIS_PROPS,
  Y_AXIS_PROPS,
} from "./chartUtils";
import { WeeklyDeficitTooltip } from "./chartUI";

export function WeeklyDeficitChart({ data, dailyGoalDeficit }) {
  return (
    <>
      <div className="flex items-center gap-4 mb-5 -mt-2 flex-wrap">
        <span className="flex items-center gap-1.5 text-[10px] font-bold text-gray-400 uppercase tracking-wider">
          <span className="w-2.5 h-2.5 rounded-sm bg-emerald-500" /> Actual
        </span>
        <span className="flex items-center gap-1.5 text-[10px] font-bold text-gray-400 uppercase tracking-wider">
          <span className="w-2.5 h-2.5 rounded-sm bg-red-500" /> Surplus
        </span>
        {dailyGoalDeficit > 0 && (
          <span className="flex items-center gap-1.5 text-[10px] font-bold text-gray-400 uppercase tracking-wider">
            <span className="w-3.5 h-0.5 bg-amber-500" /> Goal (
            {(dailyGoalDeficit * 7).toLocaleString()} kcal)
          </span>
        )}
      </div>
      <ResponsiveContainer width="100%" height={280} debounce={200}>
        <ComposedChart data={data} margin={CHART_MARGIN}>
          <CartesianGrid {...GRID_PROPS} />
          <XAxis dataKey="label" {...X_AXIS_PROPS} />
          <YAxis {...Y_AXIS_PROPS} />
          <Tooltip content={<WeeklyDeficitTooltip />} cursor={{ fill: "#ffffff08" }} />
          <ReferenceLine y={0} stroke="#ffffff20" />
          <Bar dataKey="actual" radius={[4, 4, 0, 0]} barSize={28} name="Actual Deficit">
            {data.map((entry, i) => (
              <Cell key={i} fill={entry.actual >= 0 ? "#10b981" : "#ef4444"} />
            ))}
          </Bar>
          {dailyGoalDeficit > 0 && (
            <Line
              type="stepAfter"
              dataKey="goal"
              stroke="#f59e0b"
              dot={false}
              strokeWidth={2}
              name="Weekly Goal"
            />
          )}
        </ComposedChart>
      </ResponsiveContainer>
    </>
  );
}
